/**
 * Slides | Bank — the Library's two shelves, and the hint saying what each one
 * holds.
 *
 * It was the shared `.view-nav` strip above the page body until Run 9. The row
 * moved INSIDE the page's top stack, under the title, because that is where the
 * redesign puts it and because a switch that sits above the page title reads as
 * app chrome rather than as part of this page. What did not change is that it
 * is ONE axis with two answers, and that the hint under it says what the
 * current answer means — the always-on rule that a control states its state.
 *
 * These two are LINKS in behaviour (they are separate routes, `/library` and
 * `/library/bank`), so they carry `aria-current="page"` rather than
 * `role="tab"`: there is no tabpanel here, there is a second page.
 *
 * The Bank's count arrives separately and may be null — the asset bank is a
 * different collection with its own request. A tab with no count yet shows no
 * count, rather than a 0 that is about to become 41.
 */

type Props = {
  bankMode: boolean;
  slidesCount: number;
  bankCount: number | null;
  onSelect: (path: string) => void;
};

export default function LibraryTabs({ bankMode, slidesCount, bankCount, onSelect }: Props) {
  return (
    <div className="library-tabs">
      <nav className="library-tabs__row" aria-label="Library shelves">
        <Tab label="Slides" count={slidesCount} current={!bankMode} onSelect={() => onSelect('/library')} />
        <Tab label="Bank" count={bankCount} current={bankMode} onSelect={() => onSelect('/library/bank')} />
      </nav>
      <p className="library-tabs__hint muted small">
        {bankMode
          ? 'Shared assets the AI can use on any slide: avatars, logos, brand imagery, boilerplate copy.'
          : 'Reusable items: insert them into any deck from its Add-a-slide gallery.'}
      </p>
    </div>
  );
}

function Tab({
  label,
  count,
  current,
  onSelect,
}: {
  label: string;
  count: number | null;
  current: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      className={'library-tab' + (current ? ' is-current' : '')}
      aria-current={current ? 'page' : undefined}
      onClick={onSelect}
    >
      <span>{label}</span>
      {count !== null && <span className="library-tab__count">{count}</span>}
    </button>
  );
}
